/*
 *
 * Do not edit directly
 * Generated on Thu, 24 Apr 2025 18:51:19 GMT
 *
 */

import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    open: {
      description: 'Applies when a ButtonDropdown is open.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    { if: { open: true }, tokens: { icon: PaletteIconCaretUp } },
    {
      if: { focus: true },
      tokens: {
        borderColor: '#676e73',
        color: '#414547',
        outerBorderColor: '#676e73',
        outerBorderGap: 2,
        outerBorderWidth: 2
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#676e73',
        color: '#ffffff',
        iconBackground: '#414547',
        iconColor: '#ffffff'
      }
    },
    { if: { hover: true }, tokens: { borderWidth: 3 } },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#ffffff',
        borderWidth: 0,
        color: '#b2b9bf',
        iconBackground: '#f4f4f7',
        iconColor: '#b2b9bf'
      }
    },
    {
      if: { selected: true },
      tokens: {
        backgroundColor: '#4b286d',
        borderWidth: 0,
        color: '#ffffff',
        iconBackground: '#7c53a5',
        iconColor: '#ffffff'
      }
    },
    {
      if: { hover: true, selected: true },
      tokens: { backgroundColor: '#7c53a5', iconBackground: '#613889' }
    },
    {
      if: { focus: true, selected: true },
      tokens: { outerBorderColor: '#4b286d' }
    },
    {
      if: { pressed: true, selected: true },
      tokens: { backgroundColor: '#3f2a54', iconBackground: '#613889' }
    },
    {
      if: { focus: true, pressed: true, selected: true },
      tokens: { outerBorderGap: 2, outerBorderWidth: 2 }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#ffffff',
    borderColor: '#b2b9bf',
    borderRadius: 32,
    borderWidth: 1,
    color: '#676e73',
    dividerColor: '#e3e6e8',
    fontName: 'HNforTELUSSA',
    fontSize: 14,
    fontWeight: '700',
    icon: PaletteIconCaretDown,
    iconAlignSelf: 'center',
    iconBackground: '#f4f4f7',
    iconBorderRadius: 32,
    iconColor: '#414547',
    iconPadding: 2,
    iconPosition: 'right',
    iconSize: 16,
    iconSpace: 1,
    iconTranslateX: 0,
    iconTranslateY: 0,
    lineHeight: 1.42857142857,
    minWidth: 0,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 2,
    outerBorderWidth: 2,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 8,
    paddingTop: 8,
    shadow: null,
    subtitleColor: '#676e73',
    textAlign: 'center',
    width: null
  }
}
export default theme
